export default {"src":"/_next/static/media/logo.9c2e7434.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};